import React, { Component } from "react";
import { Modal } from "antd";
import { injectIntl } from "react-intl";
import {LANGUAGE} from "../../../../constant";
import "./style.less";

class AcknowledgementLayout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showSignIn: false
    };
  }


    handleCancel = e => {
	if (e) {
	    e.preventDefault();
	}
	const { close } = this.props;
	close();
    };
    
    

  render() {

      const {children:{props:{children:contentChild=[]}={}} = {}, lang, height="100%", width="700px"} = this.props;

      let whiteContClass;
      if(lang===LANGUAGE.ARAB){
	  whiteContClass="white-container-binding-rtl";
      }
      else{
	  whiteContClass="white-container-binding";
      }

      const modalProps = {
	  visible: true,
	  onCancel: this.handleCancel,
	  wrapClassName: "global-modal full-height",
	  destroyOnClose: true,
	  bodyStyle: { height: `${height}` },
	  width: `${width}`,
	  footer: null
      };
      
    return (
	
	    <Modal {...modalProps}>
	    <div className={`${whiteContClass}`}>
	    {contentChild}
	    </div>
	   
	    </Modal>
    );
  }
}

export default injectIntl(AcknowledgementLayout);
